
<stimulsoft-viewer-angular [requestUrl]="path" [action]="'InitViewer'" [width]="'100%'"
[height]="'800px'" [properties]="properties"></stimulsoft-viewer-angular>
